module.exports = __webpack_public_path__ + "static/media/loading_button.c42b1deb.gif";